var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.96,
    height: 29.297,
    viewBox: "0 0 31.96 29.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_219",
    "data-name": "Trac\\xE9 219",
    d: "M8.322,162.449a4.986,4.986,0,0,1-4.717-3.4l-.047-.153a4.861,4.861,0,0,1-.23-1.444v-9.08L.1,159.159a3.024,3.024,0,0,0,2.12,3.669l20.592,5.515a3.054,3.054,0,0,0,.767.1,2.969,2.969,0,0,0,2.878-2.178l1.2-3.815Zm0,0",
    transform: "translate(0 -139.144)",
    fill: "#ededed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_220",
    "data-name": "Trac\\xE9 220",
    d: "M151.984,69.819a2.663,2.663,0,1,0-2.663-2.663A2.666,2.666,0,0,0,151.984,69.819Zm0,0",
    transform: "translate(-139.999 -60.497)",
    fill: "#ededed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_221",
    "data-name": "Trac\\xE9 221",
    d: "M108.625.492H88.649A3.334,3.334,0,0,0,85.32,3.822V18.47A3.334,3.334,0,0,0,88.649,21.8h19.975a3.334,3.334,0,0,0,3.329-3.329V3.822A3.334,3.334,0,0,0,108.625.492ZM88.649,3.156h19.975a.666.666,0,0,1,.666.666v9.454l-4.207-4.909a2.385,2.385,0,0,0-1.786-.819,2.328,2.328,0,0,0-1.779.84l-4.946,5.937-1.611-1.607a2.338,2.338,0,0,0-3.3,0l-3.675,3.674V3.822A.666.666,0,0,1,88.649,3.156Zm0,0",
    transform: "translate(-79.994 -0.492)",
    fill: "#ededed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.075ea06204325128d8235c8c23c90a38.svg";
export { ForwardRef as ReactComponent };